import { react2angular } from 'react2angular';
import type { IRootScopeService } from 'angular';
import angular from 'angular';

import { OfferList, OfferListTableContainer } from './OfferList';
import type { OfferListProps } from './OfferList/OfferList';

import offerListTemplate from './offer_list.html';
import type { OfferListTableContainerProps } from './OfferList/OfferListTableContainer';

interface OfferListRouteParams extends ng.route.IRouteParamsService {
  listingId: string;
}

class OfferListController {
  private listingId: string;

  constructor(
    private $rootScope: IRootScopeService,
    private ModalService: any,
    private $routeParams: OfferListRouteParams,
    private ToastService: any,
    private $scope: any,
  ) {
    this.listingId = $routeParams.listingId;
  }
}

OfferListController.$inject = [
  '$rootScope',
  'ModalService',
  '$routeParams',
  'ToastService',
  '$scope',
];

angular
  .module('caferealtor.offer.list', ['ngRoute', 'bb.appointments'])
  .config([
    '$routeProvider',
    ($routeProvider: ng.route.IRouteProvider) => {
      $routeProvider.when('/listing/:listingId/offer/', {
        template: offerListTemplate,
        controller: OfferListController,
        controllerAs: '$ctrl',
      });
    },
  ])
  .component(
    'offerList',
    react2angular<OfferListProps>(
      OfferList,
      ['showStatus', 'showActions', 'listingId'],
      [
        '$rootScope',
        'ModalService',
        '$routeParams',
        'ToastService',
        '$scope',
        '$location',
        'ErrorService',
      ],
    ),
  )
  .component(
    'offerListTable',
    react2angular<OfferListTableContainerProps>(
      OfferListTableContainer,
      ['showStatus', 'showActions', 'listing'],
      ['$rootScope', 'ModalService', '$routeParams'],
    ),
  );
